export type Vec3 = { x: number; y: number; z: number };

export type AABB = {
  minX: number;
  maxX: number;
  minY: number;
  maxY: number;
  minZ: number;
  maxZ: number;
};

/** Soft XZ playable volume — clamp / follow bounds (inside perimeter colliders). */
export type PlayBounds = {
  minX: number;
  maxX: number;
  minZ: number;
  maxZ: number;
  /** Respawn if feet drop below this. */
  killY: number;
};

/**
 * Visible ladder climb volume (ICO-style).
 * `normal` points from the wall into the approach space (where the player stands).
 * `centerX/Z` is the ladder rail axis the climber snaps to.
 */
export type Climbable = {
  aabb: AABB;
  normal: Vec3;
  bottomY: number;
  topY: number;
  centerX: number;
  centerZ: number;
};

export type Interactable = {
  id: string;
  aabb: AABB;
  prompt: string;
  used: boolean;
};

export function makeAABB(
  cx: number,
  cy: number,
  cz: number,
  hx: number,
  hy: number,
  hz: number,
): AABB {
  return {
    minX: cx - hx,
    maxX: cx + hx,
    minY: cy - hy,
    maxY: cy + hy,
    minZ: cz - hz,
    maxZ: cz + hz,
  };
}

export function pointInAABB(p: Vec3, b: AABB, pad = 0): boolean {
  return (
    p.x >= b.minX - pad &&
    p.x <= b.maxX + pad &&
    p.y >= b.minY - pad &&
    p.y <= b.maxY + pad &&
    p.z >= b.minZ - pad &&
    p.z <= b.maxZ + pad
  );
}

export function expandAABB(b: AABB, pad: number): AABB {
  return {
    minX: b.minX - pad,
    maxX: b.maxX + pad,
    minY: b.minY - pad,
    maxY: b.maxY + pad,
    minZ: b.minZ - pad,
    maxZ: b.maxZ + pad,
  };
}
